import { useState, useCallback } from "react"

// Small mutation helper used across features: tracks idle/pending/success/error
// and normalizes server validation errors to a string array. (Mirrors the
// inline helper that was duplicated in feature hooks.)
export function useMutation(fn) {
  const [status, setStatus] = useState("idle")
  const [error, setError] = useState(null)

  const mutate = useCallback(async (...args) => {
    setStatus("pending")
    setError(null)
    try {
      const result = await fn(...args)
      setStatus("success")
      return result
    } catch (err) {
      const msg = err.response?.data?.errors || [err.message || "Something went wrong"]
      setError(msg)
      setStatus("error")
      throw msg
    }
  }, [])

  return {
    mutate,
    status,
    error,
    isPending: status === "pending",
    reset: () => { setStatus("idle"); setError(null) },
  }
}
